import { combineReducers } from 'redux';

import browserReducer from 'jsx/layout/BrowserProvider/ducks';
import localeReducer from 'jsx/locale/ducks';
import modalReducer from 'jsx/elements/modals/Modal/ducks';
import sidebarReducer from 'jsx/layout/Sidebar/ducks';
import sharedReducer from 'jsx/ducks/shared';
import userReducer from 'jsx/ducks/user';
import headerReducer from 'jsx/layout/Header/ducks';

import calculatorReducer from './ducks/calculator';
import claimtrackerReducer from './ducks/claimtracker';
import dduploadReducer from './ducks/ddupload';


const rootReducer = combineReducers({
  calculator: calculatorReducer,
  claimtracker : claimtrackerReducer,
  ddupload : dduploadReducer,
  user: userReducer,
  shared: sharedReducer,
  locale: localeReducer,
  browser: browserReducer,
  header: headerReducer,
  modal: modalReducer,
  sidebar: sidebarReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducer.js